/* Dependencies */
import styled, { css } from 'styled-components';

export const Body = styled.div`
  padding: 20px;
`;
Body.displayName = 'MoveStudentsModalBody';

const selecterDisabledStyles = css`
  opacity: 0.5;
  pointer-events: none;
`;
interface IBodySelecterWrapper {
  theme?: any;
  disabled?: boolean;
}

export const BodySelecterWrapper = styled.div<IBodySelecterWrapper>`
  margin: 20px 0;
  position: relative;

  ${({ disabled = false }) => (disabled ? selecterDisabledStyles : ``)}

  .legoSelecterOptionsContainer {
    overflow: auto;
    margin-top: -2px;
    max-height: 210px;
    .legoSelecterItemLabel {
      padding: 5px;
    }
  }
`;
BodySelecterWrapper.displayName = 'MoveStudentsModalBodySelecterWrapper';

export const BodyButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-top: 125px;
  justify-content: flex-end;
`;
BodyButtonWrapper.displayName = 'MoveStudentsModalBodyButtonWrapper';

export const SuccessModalWrapper = styled.div`
  h2 {
    font-weight: normal;
  }
  img {
    width: 60px;
    height: auto;
    margin: 60px auto;
  }
`;
SuccessModalWrapper.displayName = 'MoveStudentsModalSuccessModalWrapper';

export const SuccessModalImage = css`
  width: 60px;
  height: auto;
  margin: 60px auto;
`;

export const SuccessModalTitle = css`
  font-weight: normal;
`;
